import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-go-green-opted-in',
  template: `
    <div class="done-container">
      <img class="benefit__item--icon" src="/media/static/app/browser/assets/go-green/leaf.svg" width="50" height="50" />
      <p class="thank-you">Thank you for choosing "Go Green".</p>
    </div>
  `,
  styles: [
    `
      .done-container {
        margin-top: 10vh;
        margin-bottom: 10vh;
        text-align: center;

        p {
          margin-top: 20px;
        }

        .thank-you {
          font-size: 20pt;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoGreenOptedInComponent {}
